import Services from '@/services/index';
import { VT } from '@/store/types';

export default {
  [VT.TAGS_LOAD]: ({ dispatch, getters, commit }, { useCache }) => {
    return new Promise((resolve, reject) => {
      if (useCache === true && getters.cached) {
        resolve();
      } else {
        Services.tags.raw('').then(({ data }) => {
          if (data.has_changes) { commit(VT.TAGS_LOAD, { data }); }
          resolve();
        }).catch((err) => { console.warn(err); reject(err); });
      }
    });
  },

  // Flushes cache
  // [VT.TAGS_FLUSH]: ({ commit }, backend = false) => {
  //   return new Promise((resolve, reject) => {
  //     if (!backend) {
  //       commit(VT.TAGS_FLUSH);
  //       resolve();
  //     } else {
  //       Services.tags.flush().then(() => {
  //         commit(VT.TAGS_FLUSH);
  //         resolve();
  //       }).catch(() => {
  //         commit(VT.TAGS_FLUSH);
  //         reject();
  //       });
  //     }
  //   });
  // },

  [VT.TAGS_TREE_LOAD_DELAY]: ({ getters, dispatch }, { id }) => {
    return new Promise((resolve, reject) => {
      dispatch(VT.TAGS_LOAD, { useCache: true }).then(() => {
        resolve(getters.getSingleLevelChildren({ id }));
      }).catch(() => { reject(); });
    });
  },

  [VT.TAGS_SEARCH_FLAT]: ({ getters, dispatch }, {
    query, customFilter
  }) => {
    return new Promise((resolve, reject) => {
      dispatch(VT.TAGS_LOAD, { useCache: true }).then(() => {
        resolve(getters.searchTags({
          query, customFilter
        }));
      }).catch(() => { reject(); });
    });
  },

  [VT.TAGS_SEARCH_TREE]: ({ getters, dispatch }, {
    query, customFilter, fillChildren, mergeWithInfo,
  }) => {
    return new Promise((resolve, reject) => {
      dispatch(VT.TAGS_LOAD, { useCache: true }).then(() => {
        resolve(getters.searchTagsTree({
          query, customFilter, fillChildren, mergeWithInfo
        }));
      }).catch((err) => { console.warn(err); reject(); });
    });
  },

  // Can lookup path of tag either by passing ids to lookup, od id of tag -> its path will be returned with resolved tags
  [VT.TAGS_LOOKUP_PATH]: ({ getters, dispatch }, { id, ids }) => {
    return new Promise((resolve, reject) => {
      dispatch(VT.TAGS_LOAD, { useCache: true }).then(() => {
        if (!ids || !Array.isArray(ids)) {
          const target = getters.lookupTagById({ id });
          if (!target) {
            reject(new Error(`Tag not found id=${id}`)); // @NICE could make a request to backend here
            return;
          }
          ids = target.pathArr;
        }
        resolve(getters.lookupTagsByIds({ ids }));
      }).catch((err) => { reject(err); });
    });
  },

};
